import { types, isType, getParent } from "mobx-state-tree"
import { getMvuBalance as getMvuBalanceContract } from "../contract/Token"
import { getUser } from "../api-calls/user"
import { getSingleWager, getAllUserWagers } from "../api-calls/wagers"
import { getSingleEvent } from "../api-calls/events"
import { getCustomWagersByWagerId } from "../api-calls/customWagers"
import { getEventsByTeamId, getEventsByLeagueId, getEventsByCategoryId } from "../api-calls/events";
import { getSingleTeam } from "../api-calls/teams";
import { getSingleLeague } from "../api-calls/leagues";
import { getSingleCategory } from "../api-calls/categories";
// Models
import { Wager } from "../models/Wager"
import {PoolWager} from '../models/PoolWager'
import { CustomWager } from "../models/CustomWager"
import { Event } from "../models/Event"
import { User } from "../models/User"
import { Team } from "../models/Team"
import { League } from "../models/League"
import { Category } from "../models/Category"
import { getTeamInfo } from "../api-calls/sportsDbApi";
import { getWinner, getSettled } from "../contract/Wagers";


const UserStoreModel = types
    .model('UserStore', {
        loading: types.boolean,
        loaded: types.boolean,
        diceTermsAgreedTo: types.boolean,
        user: User,
        bets: types.array(Wager),
        betsMade: types.map(Wager),
        betsTaken: types.map(Wager),
        poolBets: types.array(PoolWager),
        loadedBets: types.boolean,
        betsMadeEvents: types.map(Event),
        betsTakenEvents: types.map(Event),
        allCustomWagersMade: types.map(CustomWager),
        customWagersMade: types.map(CustomWager),
        customWagersTaken: types.map(CustomWager),
        teamsFollowedEvents: types.map(Event),
        leaguesFollowedEvents: types.map(Event),
        categoriesFollowedEvents: types.map(Event),
        allFollowedEvents: types.map(Event),
        teamsFollowedList: types.map(Team),
        leaguesFollowedList: types.map(League),
        categoriesFollowedList: types.map(Category),
        betToTake: types.optional(types.string, "")
    })
    .views(self => {
        return {
            isLoaded: () => self.loaded,
            isBetsLoaded: () => self.loadedBets,
            isLoading: () => self.loading
        }
    })
    .actions(self => {
        return {
            getMvuBalance: async () => {
                getMvuBalanceContract().then((balance) => {
                    self.setMvuBalance(Number(balance));
                });
            },
            updateUser: async (auth) => {
                self.setLoading(true);
                self.setLoaded(false);
                getUser(auth, self.user._id).then((user) => {
                    self.setUser(user);
                    self.setLoading(false);
                    self.setLoaded(true);
                });

            },
            updateBets: async (bets) => {
                self.bets = [];
                bets.forEach(bet => {
                    self.setBets(bet);
                });

            },
            updatePoolBets: async (bets) => {
                self.poolBets = [];
                bets.forEach(bet => {
                    self.setPoolBets(bet);
                });

            },
            setBetToTake: async (betId) => {
                self.betToTake = betId;

            },
            updateUserBets: async (auth) => {
                getUser(auth, self.user._id).then((user) => {
                  //  self.setUserBets(user);
                    self.setUserFollows(user);
                });
            },
            setMvuBalance: (balance) => {
                self.user.mvuBalance = balance
            },
            setUser: async (user) => {
                self.setLoading(true);
                self.setLoaded(false);
                self.user = user;
                //self.setUserBets(user);
                self.setUserFollows(user);
                self.setLoading(false);
                self.setLoaded(true);
            },
            setUserBets: async (user) => {
                //self.resetUserBetsMade();
                //self.resetUserBetsTaken();
                //self.resetUserCustomWagersMade();
               // self.resetUserCustomWagersMade();
                //self.resetAllUserCustomWagers();
                //self.setUserCustomWagersMade(user.customWagersMade);
              //  self.setUserCustomWagersTaken(user.customWagersTaken);
                //self.setBetsMade(user.betsMade);
                //self.setBetsTaken(user.betsTaken);
                //self.setBets(user)
            },
            setUserFollows: async (user) => {
                self.resetUserFollowedTeamEvents();
                self.resetUserFollowedLeagueEvents();
                self.resetUserFollowedCategoryEvents();
                self.resetUserFollowedTeamsList();
                self.resetUserFollowedLeaguesList();
                self.resetUserFollowedCategoriesList();
                self.resetUserFollowedAllEvents();
                self.setUserFollowedTeamEvents(user.teamsFollowed);
                self.setUserFollowedLeagueEvents(user.leaguesFollowed);
                self.setUserFollowedCategoryEvents(user.categoriesFollowed);
                self.setUserFollowedTeamsList(user.teamsFollowed);
                self.setUserFollowedLeaguesList(user.leaguesFollowed);
                self.setUserFollowedCategoriesList(user.categoriesFollowed);
            },
            setUserFollowedTeamEvents: async (teamsFollowed) => {
                teamsFollowed.forEach(teamId => {
                    getEventsByTeamId(teamId).then((events) => {
                        self.pushUserFollowedTeamEvents(events);
                    })
                });
            },
            pushUserFollowedTeamEvents: async (events) => {
                events.forEach(event => {
                    self.teamsFollowedEvents.put(event);
                    self.allFollowedEvents.put(event);
                });
            },
            setUserFollowedLeagueEvents: async (leaguesFollowed) => {
                leaguesFollowed.forEach(leagueId => {
                    getEventsByLeagueId(leagueId).then((events) => {
                        self.pushUserFollowedLeagueEvents(events);
                    })
                });
            },
            pushUserFollowedLeagueEvents: async (events) => {
                events.forEach(event => {
                    self.leaguesFollowedEvents.put(event);
                    self.allFollowedEvents.put(event);
                });
            },
            setUserFollowedCategoryEvents: async (categoriesFollowed) => {
                categoriesFollowed.forEach(categoryId => {
                    getEventsByCategoryId(categoryId).then((events) => {
                        self.pushUserFollowedCategoryEvents(events);
                    })
                });
            },
            pushUserFollowedCategoryEvents: async (events) => {
                events.forEach(event => {
                    self.categoriesFollowedEvents.put(event);
                    self.allFollowedEvents.put(event);
                });
            },
            setUserFollowedTeamsList: async (teamsFollowed) => {
                teamsFollowed.forEach(teamId => {
                    getSingleTeam(teamId).then((team) => {
                        self.pushUserFollowedTeamsList(team);
                    })
                });
            },
            pushUserFollowedTeamsList: async (team) => {
                self.teamsFollowedList.put(team);
            },
            setUserFollowedLeaguesList: async (leaguesFollowed) => {
                leaguesFollowed.forEach(leagueId => {
                    getSingleLeague(leagueId).then((league) => {
                        self.pushUserFollowedLeaguesList(league);
                    })
                });
            },
            pushUserFollowedLeaguesList: async (league) => {
                self.leaguesFollowedList.put(league);
            },
            setUserFollowedCategoriesList: async (categoriesFollowed) => {
                categoriesFollowed.forEach(categoryId => {
                    getSingleCategory(categoryId).then((category) => {
                        self.pushUserFollowedCategoriesList(category);
                    })
                });
            },
            pushUserFollowedCategoriesList: async (category) => {
                self.categoriesFollowedList.put(category);
            },
            setUserFollowedTeamsList: async (teamsFollowed) => {
                teamsFollowed.forEach(teamId => {
                    getSingleTeam(teamId).then((team) => {
                        self.pushUserFollowedTeamsList(team);
                    })
                });
            },
            pushUserFollowedTeamsList: async (team) => {
                self.teamsFollowedList.put(team);
            },
            setBets: async (bet) => {
                self.bets.push(bet);


                // getAllUserWagers(user._id).then(wagers => {
                //     console.log("wagers found: " + wagers);
                //     if (typeof wagers !== 'undefined')
                //     self.pushUserBets(wagers);


                // });

            },
            setPoolBets: async (bet) => {
                self.poolBets.push(bet);
            },
            pushUserBets: async (bets) => {
                for (let bet of bets) {
                    console.log(bet._id);
                }

            },
            // setBetsMade: async (wagers) => {
            //     for (let wager of wagers) {
            //         getSingleWager(wager).then((wagersFromApi) => {
            //             self.pushBetsMade(wagersFromApi);
            //         });
            //     }
            // },
            // setBetsTaken: async (wagers) => {
            //     for (let wager of wagers) {
            //         getSingleWager(wager).then((wagersFromApi) => {
            //             self.pushBetsTaken(wagersFromApi);
            //         });
            //     }
            // },
            setUserCustomWagersMade: async (wagers) => {
                for (let wager of wagers) {
                    getCustomWagersByWagerId(wager).then((wagersFromApi) => {
                        self.pushUserCustomWagersMade(wagersFromApi);
                        self.pushAllUserCustomWagers(wagersFromApi);
                    });
                }
            },
            pushUserCustomWagersMade: async (wager) => {
                self.customWagersMade.put(wager);
                // console.log("From UserStore.js, Added CustomBetMade :" + JSON.stringify(wager));
            },
            setUserCustomWagersTaken: async (wagers) => {
                for (let wager of wagers) {
                    getCustomWagersByWagerId(wager).then((wagersFromApi) => {
                        self.pushUserCustomWagersTaken(wagersFromApi);
                        self.pushAllUserCustomWagers(wagersFromApi);
                    });
                }
            },
            pushUserCustomWagersTaken: async (wager) => {
                self.customWagersTaken.put(wager);
                //console.log("From UserStore.js, Added CustomBetTaken :" + JSON.stringify(wager));
            },
            pushAllUserCustomWagers: async (wager) => {
                self.allCustomWagersMade.put(wager);
            },
            pushBetsMade: async (wagers) => {
                for (let wager of wagers) {

                    getSingleEvent(wager.eventId).then((event) => {
                        self.pushBetsMadeEvents(event);
                    });
                    let newWager = wager;

                    self.checkBlockchainSettled(wager).then((settled) => {

                        if (settled) {
                            newWager.settled = true;

                            self.checkBlockchain(wager).then((winner) => {
                                console.log("winner is " + winner);
                                if (winner === "0x0000000000000000000000000000000000000000") {


                                    newWager.winner = "unable to determine";
                                } else {
                                    if (winner.toUpperCase() === self.user.publicAddress.toUpperCase()) {
                                        newWager.winner = wager.maker;
                                    } else {
                                        newWager.winner = wager.taker;
                                    }


                                }
                                self.addBetMade(newWager);
                            });

                        } else {
                            self.addBetMade(wager);
                        }


                    });

                    if (newWager.winner === wager.maker) {
                        self.addBetWon();
                    }

                    //console.log("From UserStore.js, Added BetMade :" + JSON.stringify(wager));
                }
            },
            pushBetsTaken: (wagers) => {
                for (let wager of wagers) {
                    getSingleEvent(wager.eventId).then((event) => {
                        self.pushBetsTakenEvents(event);
                    });
                    let newWager = wager;
                    self.checkBlockchainSettled(wager).then((settled) => {

                        if (settled) {
                            newWager.settled = true;

                            self.checkBlockchain(wager).then((winner) => {
                                console.log("winner is " + winner);
                                if (winner === "0x0000000000000000000000000000000000000000") {

                                    newWager.winner = "unable to determine";

                                } else {
                                    if (winner.toUpperCase() === self.user.publicAddress.toUpperCase()) {
                                        newWager.winner = wager.taker;
                                    } else {
                                        newWager.winner = wager.maker;
                                    }


                                }

                                self.addBetTaken(newWager);

                            });
                        } else {
                            self.addBetTaken(wager);
                        }


                    });


                    if (newWager.winner === wager.taker) {
                        self.addBetWon();
                    }
                    //console.log("From UserStore.js, Added BetTaken :" + JSON.stringify(wager));

                }
            },
            checkBlockchain: (wager) => {
                return getWinner(wager.bytes32Id).then((winner) => {

                    return winner;
                })

            },

            checkBlockchainSettled: (wager) => {
                return getSettled(wager.bytes32Id).then((settled) => {

                    return settled;
                })

            },
            addBetWon: () => {
                self.user.numBetsWon += 1;

            },
            addBetTaken: (wager) => {
                self.betsTaken.put(wager);
            },
            addBetMade: (wager) => {
                self.betsMade.put(wager);
            },
            pushBetsMadeEvents: (event) => {
                self.betsMadeEvents.put(event);
            },
            pushBetsTakenEvents: (event) => {
                self.betsTakenEvents.put(event);
            },
            resetUserFollowedTeamEvents: () => {
                self.teamsFollowedEvents = {};
            },
            resetUserFollowedLeagueEvents: () => {
                self.leaguesFollowedEvents = {};
            },
            resetUserFollowedCategoryEvents: () => {
                self.categoriesFollowedEvents = {};
            },
            resetUserFollowedAllEvents: () => {
                self.allFollowedEvents = {};
            },
            resetUserFollowedTeamsList: () => {
                self.teamsFollowedList = {};
            },
            resetUserFollowedLeaguesList: () => {
                self.leaguesFollowedList = {};
            },
            resetUserFollowedCategoriesList: () => {
                self.categoriesFollowedList = {};
            },
            resetUserBetsMade: () => {
                self.betsTaken = {};
            },
            resetUserBetsTaken: () => {
                self.betsTaken = {};
            },
            resetAllUserCustomWagers: () => {
                self.allCustomWagersMade = {};
            },
            resetUserCustomWagersMade: () => {
                self.customWagers = {};
            },
            resetUserCustomWagersTaken: () => {
                self.customWagers = {};
            },
            setLoading: (loading) => {
                self.loading = loading;
            },
            setLoaded: (loaded) => {
                self.loaded = loaded;
            },
            setBetsLoaded: () => {
                self.loadedBets = true;
                //console.log("Bets Loaded from UserStore.js")
            },
            setDiceTermsAgreedTo: (agreedBool) => {
                self.diceTermsAgreedTo = agreedBool;
            }
        }
    });

const UserStore = UserStoreModel.create({
    loaded: false,
    loading: false,
    diceTermsAgreedTo: false,
    user: {
        _id: "types.identifier",
        nonce: 1,
        username: "types.string",
        role: "guest",
        publicAddress: "types.string",
        mvuBalance: 0,
        mvuAllowance: 0,
        betsMade: [],
        betsTaken: [],        
        totalAmountBet: 0,
        numBetsWon: 0,
        termsAgreedTo: false,
        teamsFollowed: [],
        leaguesFollowed: [],
        categoriesFollowed: [],
        amountEthWon: 0
    },
    loadedBets: false,
    bets: [],
    poolBets: [],
    betsMade: {},
    betsTaken: {},
    betsMadeEvents: {},
    betsTakenEvents: {},
    allCustomWagersMade: {},
    customWagersMade: {},
    customWagersTaken: {},
    teamsFollowedEvents: {},
    laguesFollowedEvents: {},
    categoriesFollowedEvents: {},
    allFollowedEvents: {},
    teamsFollowedList: {},
    leaguesFollowedList: {},
    categoriesFollowedList: {},
});

export default UserStore;


// WEBPACK FOOTER //
// ./src/stores/UserStore.js